import React, { useState, useEffect } from 'react';
import loggo from '../img/logonew.jpg';
import { Link } from 'react-router-dom';
import InfoIcon from "@mui/icons-material/Info";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import BuildIcon from "@mui/icons-material/Build";
import GavelIcon from "@mui/icons-material/Gavel";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import TwitterIcon from "@mui/icons-material/Twitter";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import HotelIcon from '@mui/icons-material/Hotel';
import EngineeringIcon from '@mui/icons-material/Engineering';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import PrivacyTipIcon from '@mui/icons-material/PrivacyTip';
import { FaTiktok } from 'react-icons/fa';

const Footer = () => {
  const [showButton, setShowButton] = useState(false);

  // Show button when the user scrolls down
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Clean up the event listener on component unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Scroll back to top when button is clicked
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      {/* Footer Start */}
      <div className="container-fluid bg-dark mt-5 py-5 wow fadeIn" data-wow-delay="0.1s">
        <div className="container py-5">
          <div className="row g-5">
            <div className="col-lg-3 col-md-6 text-center">
              <img
                src={loggo}
                alt="Company Logo"
                className="img-fluid mb-3"
                style={{ maxHeight: "80px" }} // Adjust size
              />
              <p className="text-white text-start">
                We provide high-quality equipment solutions for all your industrial needs.
                Trusted by clients for over 5 years, delivering excellence and reliability.
              </p>
            </div>

            <div className="col-lg-3 col-md-6">
              <h5 className="text-white mb-4">Quick Links</h5>
              <Link to="/about" className="btn btn-link text-start text-light d-block footer-link">
                <InfoIcon className="me-2" /> About Us
              </Link>
              <Link to="/contact" className="btn btn-link text-start text-light d-block footer-link">
                <ContactMailIcon className="me-2" /> Contact Us
              </Link>
              <Link to="/services" className="btn btn-link text-start text-light d-block footer-link">
                <BuildIcon className="me-2" /> Our Services
              </Link>
              <Link to="/terms" className="btn btn-link text-start text-light d-block footer-link">
                <GavelIcon className="me-2" /> Terms &amp; Condition
              </Link>
              <Link to="/privacypolicy" className="btn btn-link text-start text-light d-block footer-link">
                <PrivacyTipIcon className="me-2" />Privacy Policy
              </Link>
            </div>

            <div className="col-lg-3 col-md-6">
              <h5 className="text-white mb-4">Our Services</h5>

              <Link to="/services" className="btn btn-link text-start text-light d-block footer-link">
                <HotelIcon className="me-2" />
                Hospitality & Dining
              </Link>
              <Link to="/services" className="btn btn-link text-start text-light d-block footer-link">
                <BuildIcon className="me-2" />
                Custom Metal Fabrication
              </Link>
              <Link to="/services" className="btn btn-link text-start text-light d-block footer-link">
                <EngineeringIcon className="me-2" />
                Civil & Structural Works
              </Link>
              <Link to="/services" className="btn btn-link text-start text-light d-block footer-link">
                <HomeRepairServiceIcon className="me-2" />
                Interior & Exterior Fit-Out
              </Link>
            </div>

            {/* </div> */}

            <div className="col-lg-3 col-md-6">
              <h5 className="text-white mb-4">Our Location</h5>
              <p className="mb-2 text-white">
                <LocationOnIcon style={{ color: "white", verticalAlign: "middle" }} className="me-2" />
                P.O. Box 76560-00508 NAIROBI
              </p>
              <p className="mb-2">
                <PhoneIcon style={{ color: "white", verticalAlign: "middle" }} className="me-2" />
                <a href="tel:+254708022458" className="text-white">
                  +254 708 022458
                </a>
                {" / "}
                <a href="tel:+254732964488" className="text-white">
                 +254 732 964488
                </a>
              </p>

              <p className="mb-2">
                <EmailIcon style={{ color: "white", verticalAlign: "middle" }} className="me-2" />
                <a href="mailto:tarun@swiftkey.co.ke" className="text-white">
                 tarun@swiftkey.co.ke
                </a>
              </p>


              <div className="d-flex pt-3">
                <a
                  className="btn btn-square btn-primary rounded-circle me-2 d-flex align-items-center justify-content-center"
                  href="https://x.com/SwiftkeyL30443" target="_blank" rel="noopener noreferrer"
                >
                  <TwitterIcon style={{ color: "white" }} />
                </a>
                <a
                  className="btn btn-square btn-primary rounded-circle me-2 d-flex align-items-center justify-content-center"
                  href="https://www.facebook.com/profile.php?id=61583828638745" target="_blank" rel="noopener noreferrer"
                >
                  <FacebookIcon style={{ color: "white" }} />
                </a>
                <a
                  className="btn btn-square btn-primary rounded-circle me-2 d-flex align-items-center justify-content-center"
                  href="https://youtube.com/@swiftkeydevelopmentlimited?si=na9gk9vQlfsGvXrN" target="_blank" rel="noopener noreferrer"
                >
                  <YouTubeIcon style={{ color: "white" }} />
                </a>
                <a
                  className="btn btn-square btn-primary rounded-circle me-2 d-flex align-items-center justify-content-center"
                  href="https://www.instagram.com/swiftkeydevelopmentltd/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <InstagramIcon style={{ color: "white" }} />
                </a>
                <a
                  className="btn btn-square btn-primary rounded-circle me-2 d-flex align-items-center justify-content-center"
                  href="https://www.linkedin.com/company/swiftkey-development-ltd/" target="_blank" rel="noopener noreferrer"
                >
                  <LinkedInIcon style={{ color: "white" }} />
                </a>

                <a
                  className="btn btn-square btn-primary rounded-circle me-2 d-flex align-items-center justify-content-center"
                  href="https://www.tiktok.com/@swiftkeydevelopmentltd"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaTiktok color="white" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <p className="text-center copyright-text">
          © {new Date().getFullYear()} Swiftkey Development Limited | Hospitality Construction & Commercial Kitchen Experts in Nairobi, Kenya | Built by{" "}
          <a
            href="https://nuicloudtechnologies.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#66df0a", textDecoration: "none", fontWeight: "600" }}
          >
            NuiCloud Technologies
          </a>
        </p>      </div>

      {/* Footer End */}

      {/* Back to Top Button */}
      {
        showButton && (
          <button
            className="btn btn-lg btn-primary btn-lg-square rounded-circle back-to-top"
            onClick={scrollToTop}
            style={{
              position: 'fixed',
              bottom: '30px',
              right: '30px',
              zIndex: 9999,
            }}
          >
            <ArrowUpwardIcon style={{ color: "white", margin: "0 0 0 -5px" }} />
          </button>
        )
      }
    </>
  );
};

export default Footer;
